import React, {useContext} from 'react';
import {injectIntl} from "react-intl";
import AutoSuggestField from "@FormElements/AutoSuggestField";
import FormContext from "formContext";
import {useCountriesList} from "i18nHelper";

function CountryAutoSuggest({intl, settings, locale,   ...rest}) {
  const {currentStep, setFormData, formData} = useContext(FormContext);

  const {countries} = useCountriesList(locale);
  let countryOptions = [];
  let countryFiltered = [];
  if (countries) {
    countryOptions = Object.keys(countries).map(function(key) {
      const value = countries[key];
      if (formData && formData[currentStep] && formData[currentStep][settings.name]) {
        const formValue = formData[currentStep][settings.name];
        const match = value.toLowerCase().indexOf(formValue.toLowerCase()) !== -1;

        if (match) {
          countryFiltered.push(countries[key]);
        }
      }
      return countries[key];
    });

    // Bind initial country with a valid one from countries list.
    Object.keys(countries).map(function(key) {
      const value = countries[key];
      if (formData && formData[currentStep] && formData[currentStep][settings.name]) {
        const formValue = formData[currentStep][settings.name];
        const fullMatch = value.toLowerCase() === formValue.toLowerCase();

        // Check for complete match and set the country in form state.
        // Ensure it is being set only once by checking the countryCode.
        if (fullMatch && !settings.state.countryCode) {
          let countryValue = countries[key];
          setFormData(prev => {
            if (!prev[currentStep][settings.name]) {
              prev[currentStep][settings.name] = '';
              prev[currentStep]['countryCode'] = '';
            }
            prev[currentStep][settings.name] = countryValue;
            prev[currentStep]['countryCode'] = key;
            return {
              ...prev
            }
          });
        }
      }
    });
  }

  if (countryFiltered.length > 0) {
    settings.options = countryFiltered;
  } else {
    settings.options = countryOptions;
  }

  rest.onChange = e => {
    const {value} = e.target;
    const match = countryOptions.find(el => el === value);
    let matchedCountryCode = '';
    // Get country code from additionalData and store in form
    Object.keys(countries).map(key => {
      let currentValue = countries[key];
      if (currentValue.toLowerCase().indexOf(value.toLowerCase()) !== -1) {
        matchedCountryCode = key;
      }
    });
    if (match) {
      setFormData(prev => {
        if (!prev[currentStep][settings.name]) {
          prev[currentStep][settings.name] = '';
          prev[currentStep]['countryCode'] = '';
        }
        prev[currentStep][settings.name] = match;
        prev[currentStep]['countryCode'] = matchedCountryCode;
        return {
          ...prev
        }
      });
    }
    else {
      setFormData(prev => {
        if (!prev[currentStep]) {
          prev[currentStep] = {};
        }
        prev[currentStep][settings.name] = value;
        prev[currentStep]['countryCode'] = '';
        return {
          ...prev
        }
      });
    }
  };

  return (
    <AutoSuggestField
      settings={settings}
      {...rest}
    />
  );
}

export default injectIntl(CountryAutoSuggest);
